// extracted by mini-css-extract-plugin
export default {"P__container":"PasswordResetConfirmRequired_P__container__Z-3r1"};